export const OrganizationInfo = {
  CHANNEL_TALK: 'https://gatherplz.channel.io',
  EMAIL: 'gatherplz@gmail.com',
  COPYRIGHT: '© 2023. Team(TBIN). All rights reserved',
};
